export const request = {
  namespaced: true,
  state: {
    cancelAbortControllers: [],
    module: 1
  },
  getters: {
    cancelAbortController(state) {
      return state.cancelAbortControllers;
    }
  },
  mutations: {
    ADD_CANCEL_ABORT_CONTROLLER(state, controller) {
      state.cancelAbortControllers.push(controller);
    },
    CLEAR_CANCEL_ABORT_CONTROLLERS(state) {
      state.cancelAbortControllers = [];
    },
    changeModule(state, module) {
      state.module = module;
    }
  },
  actions: {
    CANCEL_PENDING_REQUESTS(context) {
      context.state.cancelAbortControllers.forEach((controller) => {
        if(controller && controller.abort) {
          controller.abort();
        }
      })

      context.commit('CLEAR_CANCEL_ABORT_CONTROLLERS');
    }
  }
  
  
}